import styled from "styled-components";

const DropdownRows = styled.ul`
  padding-left: 0px;
  margin-top: 0px;
  position: absolute;
  width: 100%;
`;

const DropDownWrapper = styled.div`
  width: 465px;
  background: #FFFFFF;
  border: 1px solid #E5E5E5;
  position: absolute;
  z-index: 1;
  margin-top: -1px;
  margin-left: -1px;
  overflow: auto;
  height: 217px;

  .empty_list {
    left: 186px;
    position: absolute;
    top: 88px;
    width: 70px;
    color: #bdb5b5;
  }
`;

const DropdownRow = styled.li`
  list-style: none;
  cursor: pointer;
  padding: 12px;
  border-bottom: solid 1px #E5E5E5;

  &:hover {
    background-color: #FCEDF3;
  }
`;
const DropdownOptions = (props) => {
    const {list, handleSelection} = props;
    return (
        <DropDownWrapper>
            <DropdownRows>
                {list.length === 0 ? <div className={"empty_list"}>No Options</div> : list?.map(row => {
                    return <DropdownRow key={row.label}
                                        onClick={() => handleSelection(row)}>{row.value}</DropdownRow>
                })}
            </DropdownRows>
        </DropDownWrapper>
    );

}
export default DropdownOptions;
